const registerGoogleMap = () => {
	// Declare map
	const googleMap = document.querySelectorAll('#map');

	// Google Maps
	googleMap.forEach((element) => {
		function createMap(el, lat, long, zoom, marker) {
			// Set a center point of the map, can be re-evaluated using `centerMap()`
			const center = { lat: lat, lng: long };

			const mapOptions = {
				zoom: zoom,
				center: center,
				fullscreenControl: false,
			};

			// Create a map instance.
			const melonMap = new MelonMap(document.getElementById(el), mapOptions);

			// Marker locations [name, lat, long, zindex]
			const markerLocation = [['Buckinghamshire Building Society', lat, long, 1]];

			if (marker == true) {
				markerLocation.forEach((markerLocation) => {
					const title = markerLocation[0];

					const location = {
						lat: parseFloat(markerLocation[1]),
						lng: parseFloat(markerLocation[2]),
					}

					melonMap.addMarker(location, title);
				});
			}

			// Add a map style
			melonMap.setMapStyle(
				[{ "featureType": "landscape", "stylers": [{ "saturation": -100 }, { "lightness": 60 }] }, { "featureType": "road.local", "stylers": [{ "saturation": -100 }, { "lightness": 40 }, { "visibility": "on" }] }, { "featureType": "transit", "stylers": [{ "saturation": -100 }, { "visibility": "simplified" }] }, { "featureType": "administrative.province", "stylers": [{ "visibility": "off" }] }, { "featureType": "water", "stylers": [{ "visibility": "on" }, { "lightness": 30 }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#ef8c25" }, { "lightness": 40 }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "visibility": "off" }] }, { "featureType": "poi.park", "elementType": "geometry.fill", "stylers": [{ "color": "#b6c54c" }, { "lightness": 40 }, { "saturation": -40 }] }, {}],
				{ name: 'Styled Map' }
			);
		}

		// Initiate google map for contact form
		createMap('map', 51.633031, -0.5714076, 12, true);
	});
}

document.addEventListener('DOMContentLoaded', () => {
	registerGoogleMap();

	const body = document.querySelector('body');

	// Helper function
	let domReady = (cb) => {
		document.readyState === 'interactive' || document.readyState === 'complete'
			? cb()
			: document.addEventListener('DOMContentLoaded', cb);
	};

	domReady(() => {
		// Display body when DOM is loaded
		body.style.visibility = 'visible';
	});

	// hide cookie policy
	document.querySelector('.section-cookies .btn-accept').addEventListener('click', (e) => {
		e.preventDefault();

		// If no validation errors
		$.ajax({
			method: "POST",
			url: "api/cookies/",
			data: {
				'cookies-accepted': 1,
			}
		}).done(function () {
			$('.section-cookies').addClass('mod-hide').removeClass('show');
		});
	});

	document.querySelector('.section-cookies .btn-decline').addEventListener('click', (e) => {
		e.preventDefault();

		$.ajax({
			method: "POST",
			url: "api/cookies/",
			data: {
				'cookies-accepted': 0,
			}
		}).done(function () {
			$('.section-cookies').addClass('mod-hide').removeClass('show');
		});
	});

	// Add class to inputs when clicked on add effect
	const form = document.querySelectorAll('form');

	if (form) {
		document.querySelectorAll('form input, form textarea').forEach((element) => {
			element.addEventListener('focus', () => {
				element.parentElement.classList.add('mod-filled');
			});

			element.addEventListener('blur', () => {
				if (element.value) {
					element.parentElement.classList.add('mod-filled');
				} else {
					element.parentElement.classList.remove('mod-filled');
				}
			});
		});
	}

	const contactPage = document.querySelectorAll('#contact'),
	contactForm = document.querySelector('#contactForm');

	if (contactPage && contactForm) {
		// Refresh token every 90 seconds to avoid token expiry (optional but recommended)
		setInterval(() => {
			grecaptcha.ready(function () {
				grecaptcha.execute('6LfDu44rAAAAAHVGHkw9MVj_dWUjsz8n00NkJKTM', { action: 'submit' }).then(function (token) {
					let tokenField = contactForm.querySelector('input[name="g-recaptcha-response"]');
					if (!tokenField) {
						tokenField = document.createElement('input');
						tokenField.type = 'hidden';
						tokenField.name = 'g-recaptcha-response';
						contactForm.appendChild(tokenField);
					}
					tokenField.value = token;
				});
			});
		}, 90000); // Refresh token every 90s

		// Ajax contact form processing
		contactForm.addEventListener('submit', function (event) {
			event.preventDefault();

			const spamField = document.querySelector('input#Form_Email'),
				loadingSpinner = document.querySelector('.section-form .loading');

			if (spamField.value) {
				return false;
			}

			loadingSpinner.classList.add('mod-show');

			// Generate a fresh reCAPTCHA token right before AJAX submit
			grecaptcha.ready(function () {
				grecaptcha.execute('6LfDu44rAAAAAHVGHkw9MVj_dWUjsz8n00NkJKTM', { action: 'submit' }).then(function (token) {
					let tokenField = contactForm.querySelector('input[name="g-recaptcha-response"]');
					if (!tokenField) {
						tokenField = document.createElement('input');
						tokenField.type = 'hidden';
						tokenField.name = 'g-recaptcha-response';
						contactForm.appendChild(tokenField);
					}
					tokenField.value = token;

					// Submit the form via AJAX after token is attached
					$.ajax({
						method: 'POST',
						url: 'process/contact/',
						dataType: 'json',
						data: $(contactForm).serialize()
					}).done(function (response) {
						if (response == 'success') {
							loadingSpinner.classList.remove('mod-show');

							document.querySelectorAll('#contactForm .form-element').forEach((element) => {
								element.classList.remove('mod-filled');
							});

							contactForm.classList.add('mod-hide');
							contactForm.nextElementSibling.classList.add('mod-show');
							contactForm.firstElementChild.nextElementSibling.innerHTML = '';

							document.querySelectorAll('#contactForm .form-element input, #contactForm .form-element textarea').forEach((element) => {
								element.value = '';
							});
							document.querySelectorAll('#contact .sub-error').forEach((element) => {
								element.innerHTML = '';
							});
							document.querySelectorAll('#contactForm .form-element').forEach((element) => {
								element.classList.remove('mod-error');
							});

							setTimeout(function () {
								contactForm.classList.remove('mod-hide');
								contactForm.nextElementSibling.classList.remove('mod-show');
							}, 10000);

						} else {
							contactForm.scrollIntoView({ behavior: 'smooth', block: 'start' });

							loadingSpinner.classList.remove('mod-show');
							contactForm.firstElementChild.nextElementSibling.innerHTML = 'Please fix the errors below:';

							document.querySelectorAll('#contactForm .sub-error').forEach((element) => {
								element.innerHTML = '';
							});
							document.querySelectorAll('#contactForm .form-element').forEach((element) => {
								element.classList.remove('mod-error');
							});

							for (const [key, value] of Object.entries(response)) {
								if (key) {
									const errorElement = document.querySelector('#contactForm .sub-error[data-error="' + key + '"]');
									if (errorElement) {
										errorElement.innerHTML = value['message'];
									}
									if (key !== 'recaptcha') {
										const formElement = document.querySelector('#contactForm .form-element.mod-' + key);
										if (formElement) {
											formElement.classList.add('mod-error');
										}
									}
								}
							}
						}
					});
				});
			});
		});
	}

	window.addEventListener('scroll', function() {
		var scroll = window.scrollY || document.documentElement.scrollTop;

		var headerMain = document.querySelector('.header-main');
		
		if (headerMain) {
			if(scroll > 200) {
				headerMain.classList.add('mod-hide');
			} else {
				headerMain.classList.remove('mod-hide');
			}
		}
	});

	if (document.querySelector('.mod-parallax')) {
		initHeroParallax();
	}
	
	function initHeroParallax() {
		const hero = document.querySelector('.section-hero');
		const content = hero.querySelector('.content');
		const maxScroll = 400;
	
		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					window.addEventListener('scroll', handleScroll);
				} else {
					window.removeEventListener('scroll', handleScroll);
				}
			},
			{ root: null, threshold: 0 }
		);
	
		function handleScroll() {
			const rect = hero.getBoundingClientRect();
			const scrollY = -rect.top;
			const clampedScroll = Math.max(0, Math.min(scrollY, maxScroll));
			const translateY = -clampedScroll * 0.5;
			const opacity = 1 - clampedScroll / maxScroll;
	
			content.style.transform = `translateY(${translateY}px)`;
			content.style.opacity = opacity;
		}
	
		observer.observe(hero);
	}

	const arrowDown = document.querySelector('.arrow-down');
	if (arrowDown) {
		arrowDown.addEventListener('click', () => {
			const target = document.querySelector('.target');
			if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
		});
	}
	

	// Hamburger menu function
	document.querySelectorAll('.mob-hamburger').forEach((hamburger) => {
		hamburger.addEventListener('click', (e) => {
			
			e.preventDefault();

			// Add active class to hamburger so it can be animated
			hamburger.classList.toggle('mod-active');

			hamburger.setAttribute('aria-label', 'Close menu');

			// Add active class to nav to show
			document.querySelector('#nav').classList.toggle('mod-show');

			// Add no scroll class to body to prevent scrolling when nav is active
			body.classList.toggle('no-scroll');

			// Add active class to header
			document.querySelector('.header-main').classList.toggle('mod-active');

			// Add active class on all li's
			if (!hamburger.classList.contains('mod-active')) {
				hamburger.setAttribute('aria-label', 'Open menu');

				document.querySelectorAll('#nav ul li').forEach((element) => {
					element.classList.remove('mod-show');
				});

				setTimeout(function () {
					document.querySelector('#nav').classList.remove('mod-show');
				}, 550);
			} else {
				setTimeout(function () {
					document.querySelectorAll('#nav ul li').forEach((element) => {
						element.classList.add('mod-show');
					});
				}, 900);
			}
		});
	});

	const genericSlick = document.querySelectorAll('.carousel.js-slick');

	if (genericSlick.length > 0) {
		genericSlick.forEach(element => {
			$(element).slick({
				arrows: false,
				autoplay: true,
				centerMode: false,
				autoplaySpeed: 5000,
				appendDots: element.parentElement.nextElementSibling,
				dots: true,
				fade: true,
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1
			});	
		});
	}
});